import { TaskState } from 'dy-frontend-http-repository/lib/data/enums';

const taskStateColumns: TaskState[] = [
    TaskState.PUBLISHED,
    TaskState.PICKUP_READY,
    TaskState.IN_PROGRESS,
    TaskState.IN_REVISION,
    TaskState.INTERNAL_QA,
    TaskState.CLIENT_REVIEW,
    TaskState.REVISION_REQUIRED,
    TaskState.PRE_DELIVERED,
];

export default taskStateColumns;
